import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62cd1b38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion" }
const _hoisted_2 = ["data-testid", "onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "step-body" }
const _hoisted_5 = ["data-testid"]

import notSelectedNotCompleted from './icons/not-selected-not-completed.svg';
import notSelectedCompleted from './icons/not-selected-completed.svg';
import selectedNotCompleted from './icons/selected-not-completed.svg';
import selectedCompleted from './icons/selected-completed.svg';
// eslint-disable-next-line import/extensions, import/no-unresolved
import type { Step } from '../../steps';


export default /*#__PURE__*/_defineComponent({
  __name: 'accordion',
  props: {
    steps: null,
    selected: null
  },
  emits: ["onSelect"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onSelect', name: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  steps: Step[];
  selected: string;
}




const getIcon = (step: Step) => {
  if (props.selected === step.name) {
    if (step.isCompleted) {
      return selectedCompleted;
    }
    return selectedNotCompleted;
  }
  if (step.isCompleted) {
    return notSelectedCompleted;
  }
  return notSelectedNotCompleted;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "step",
        key: step.name
      }, [
        _createElementVNode("div", {
          class: "header",
          "data-testid": `step-header-${step.name}`,
          onClick: ($event: any) => (emit('onSelect', step.name))
        }, [
          _createElementVNode("img", {
            class: "icon",
            src: getIcon(step),
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: _normalizeClass(["title gordita-400-16-r text-Text/text_high cursor-pointer hover:bg-Hovers/hover_grey", { 'gordita-500-16-m': step.name === __props.selected, selected: step.name === __props.selected }])
          }, _toDisplayString(step.title), 3)
        ], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, `step-header-${step.name}`, {
            isSelected: step.name === __props.selected,
            completed: step.subSteps.completed,
            toComplete: step.subSteps.toComplete
          }),
          _createVNode(_Transition, { name: "accordion-expend" }, {
            default: _withCtx(() => [
              (step.name === __props.selected)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["content", step.name]),
                    "data-testid": `step-content-${step.name}`
                  }, [
                    _renderSlot(_ctx.$slots, `content-${step.name}`)
                  ], 10, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1024)
        ])
      ]))
    }), 128))
  ]))
}
}

})